module.exports = __webpack_public_path__ + "static/img/petroleum-coke_256.ed62a3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/petroleum-coke_256.png
// module id = k5Cu
// module chunks = 0